import PptxGenJS from 'pptxgenjs';

export default class PowerPointPresentation extends PptxGenJS {
	public slideIds: string[] = [];

	public registerSlideIds(slide: string[]): void {
		this.slideIds.push(...slide);
	}

	public getSlideNumberById(slideId: string): number {
		return this.slideIds.indexOf(slideId) + 1;
	}
}
